import { isPaid } from './isPaid';
import { AccessRequestError } from './permissions';

export class AccessRequestErrorBuilder {
    constructor(permissions, context) {
        this.context = context;
        this.permissions = permissions;
        this.billing = this.workspace.billing || {};
        this.plan = this.billing.plan;
        this.assumePaid = isPaid(this.billing, context.allowPastDue);
        this.subject = null;
        this.permission = null;
    }

    get workspace() {
        return this.context.workspace || this.context;
    }

    setPermission(permission) {
        this.permission = permission;

        return this;
    }

    setSubject(subject) {
        this.subject = subject;

        return this;
    }

    build() {
        const { context, plan, permission, subject } = this;
        const paid = this.assumePaid || this.permissions.isGranted(context, permission, subject, 'basic');
        const granted = this.permissions.isGranted(context, permission, subject);
        const upgrade = granted ? plan : this.permissions.lookupUpgrade(context, permission, subject);

        if (granted && paid) {
            return null;
        }

        const shouldPay = granted && !paid;

        if (shouldPay) {
            return new AccessRequestError(`Pay for ${plan}`, 'unpaid', plan, permission);
        }

        if (upgrade) {
            return new AccessRequestError(`Upgrade to ${upgrade}`, 'upgrade', plan, permission, upgrade);
        }

        return new AccessRequestError('Access forbidden', 'forbidden', plan, permission);
    }
}
